/** What a frame profile publishes: one window's frames, averaged per frame. */
/** The render steps a frame profile times, in the order the overlay lists them. */
export const RENDER_STEPS = [
    'SubViewports',
    'Reflection probes',
    '2D lights',
    'Scene draw',
    'Depth prepass',
    'Screen-space reflection',
    'Shadows',
    'Fog',
    'Compositor',
    'Canvas copy',
];
/** The steps whose work includes the canvas's own draw of its scene, as the compositor's scene pass. */
export const WRAPS_CANVAS_DRAW = new Set(['Compositor']);
//# sourceMappingURL=frameStats.js.map